module.exports = __webpack_public_path__ + "img/resource-intro-icon.6e2799c2.png";